import type { ComponentProps, ReactNode } from "react";
import { Badge } from "@theorgchartdev/storybook";
import { gUpgradeIndicatorIcon } from "@coreapp/whitelabel/brand";
import { UPGRADE_BADGE_PROPS } from "@/Utils/Misc";
import UpgradePopover from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradePopover";
import type { MainNavItemOption } from "./useMainNavItems";

type NavItemUpgradeBadgeProps = {
  item: MainNavItemOption;
  children: ReactNode;
};

export const NavItemUpgradeBadge = ({ item, children }: NavItemUpgradeBadgeProps) => (
  <UpgradePopover
    customTrigger={
      <Badge
        {...(UPGRADE_BADGE_PROPS as ComponentProps<typeof Badge>)}
        iconProps={{ name: gUpgradeIndicatorIcon }}
      >
        {children}
      </Badge>
    }
    // getNavOptions() always pairs showUpgrade with a featureKey — see useMainNavItems.
    featureKey={item.featureKey!}
    popoverText={item.upgradePopoverText}
    placement="right"
  />
);
